import React from "react";

function ProductCatalogBlue() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4353_4319)">
        <path
          d="M20.375 33.5215V21.1963L7.25 14.6338V32.6807L18.4062 38.2793L17.7705 40.8838L4.625 34.3213V11.6807L21.6875 3.16992L38.75 11.6807V17.2178C37.793 17.3682 36.918 17.6758 36.125 18.1406V14.6338L23 21.1963V30.8965L20.375 33.5215ZM17.4629 8.19434L29.4395 15.0439L34.5049 12.501L21.6875 6.08203L17.4629 8.19434ZM21.6875 18.9199L26.6094 16.459L14.6328 9.60938L8.87012 12.501L21.6875 18.9199ZM39.8984 20.376C40.4727 20.376 41.0059 20.4785 41.498 20.6836C41.9902 20.8887 42.4277 21.1689 42.8105 21.5244C43.1934 21.8799 43.4805 22.3105 43.6719 22.8164C43.8633 23.3223 43.9727 23.8623 44 24.4365C44 24.9697 43.8975 25.4893 43.6924 25.9951C43.4873 26.501 43.1934 26.9453 42.8105 27.3281L28.1064 42.0322L20.375 43.96L22.3027 36.2285L37.0068 21.5449C37.4033 21.1484 37.8477 20.8545 38.3398 20.6631C38.832 20.4717 39.3516 20.376 39.8984 20.376ZM40.9443 25.4824C41.2314 25.1953 41.375 24.8467 41.375 24.4365C41.375 24.0127 41.2383 23.6709 40.9648 23.4111C40.6914 23.1514 40.3359 23.0146 39.8984 23.001C39.707 23.001 39.5225 23.0283 39.3447 23.083C39.167 23.1377 39.0098 23.2402 38.873 23.3906L24.6816 37.582L23.9844 40.3506L26.7529 39.6533L40.9443 25.4824Z"
          fill="#4072C8"
        />
      </g>
      <defs>
        <clipPath id="clip0_4353_4319">
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ProductCatalogBlue;
